<template>
    <FloatingPanel title="Aanvraagformulier">
        <div class="initiatief::canvas-blocks-modules-aanvraagformulier-BlockPanel">
            <Tabs :tabs="['Maatwerk', 'Algemeen']">
                <div slot="Maatwerk">
                    <TextInput
                        label="E-mailadres notificatie"
                        instruction="E-mailadres(sen) waarnaar ingediende aanvragen worden gestuurd. Meerdere adressen scheiden met een komma."
                        :options="options"
                        options-property="email"
                        placeholder="info@impactfondsborsele.nl"
                        :open="true"
                        @valueChange="save()"
                    />
                </div>
                <div slot="Algemeen">
                    <CommonInputs :options="options"/>
                </div>
            </Tabs>
        </div>
    </FloatingPanel>
</template>

<script>
import AbstractPanel from '@galaxy/modules/Canvas/resources/js/editor/website/editors/AbstractPanel';
import FloatingPanel from '@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/FloatingPanel';
import CommonInputs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/CommonInputs";
import Tabs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/Tabs";
import TextInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/TextInput";

export default {
    extends: AbstractPanel,
    components: { FloatingPanel, CommonInputs, Tabs, TextInput },
}
</script>

<style lang="scss" scoped>
.initiatief\:\:canvas-blocks-modules-aanvraagformulier-BlockPanel { }
</style>
